import { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { CnpTypes } from "../Models/CnpTypes";

interface IProps {
    cnpType: number
    cnpTypeUpdated: (cnpType: number) => void
}

export function CnpOptions(props: IProps) {

    let [cnpType, setCnpType] = useState(props.cnpType);

    useEffect(() => {
        setCnpType(props.cnpType);
    })

    const updateCnpType = (value: number) => {
        let newValue = value == cnpType ? null : value;

        setCnpType(newValue);
        props.cnpTypeUpdated(newValue);
    }

    return (
        <Form.Group>
            <Form.Text className="font-weight-bold">Select one<span className="text-pp-primary ml-2">*</span></Form.Text>
            {Object.keys(CnpTypes).map(key =>
                <Form.Check key={key} type="radio">
                    <Form.Check.Input type="radio"
                        checked={cnpType === parseInt(key)}
                        onChange={() => updateCnpType(parseInt(key))} />
                    <Form.Check.Label className="mb-1 pp-font-size-smaller">{CnpTypes[parseInt(key)]}</Form.Check.Label>
                </Form.Check>
            )}
        </Form.Group>
    );
}
export default CnpOptions;